"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCustomerPaymentMethod = exports.customerPaymentMethodRuleSet = void 0;
var typeguards_1 = require("../../../typeguards");
var typeguards_2 = require("../../../typeguards");
exports.customerPaymentMethodRuleSet = {
  type: typeguards_1.isNonEmptyString,
  token: typeguards_1.isNonEmptyString,
  email: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  is_default: typeguards_1.isBool,
  card_type: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  cardholder: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  is_expired: typeguards_1.isBool,
  last4: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  expiration_month: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  expiration_year: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString),
  postcode: (0, typeguards_2.optional)(typeguards_1.isNonEmptyString)
};
var isCustomerPaymentMethod = function (input) {
  return (0, typeguards_1.isType)(input, exports.customerPaymentMethodRuleSet);
};
exports.isCustomerPaymentMethod = isCustomerPaymentMethod;